<template>
  <DropdownButton text="一覧へ" size="font-bold text-white rounded bg-transparent" :menus="menu" @select="select">
    <LoadingIcon v-if="isLoading" slot="before" class="h-4 w-4" />
    <Icon v-if="!isLoading" iconName="ClipboardList" slot="before" class="h-5 w-5" />
    <Icon iconName="ChevronDown" slot="after" class="h-5 w-5" />
  </DropdownButton>
</template>

<script>
import DropdownButton from '@components/DropdownButton.vue'
import Icon from '@components/Icon.vue'
import LoadingIcon from '@assets/loading-circle.svg' 

const menu = [
  {
    value: 'main',
    text: 'メインタスク一覧'
  },
  {
    value: 'sub',
    text: '進捗一覧'
  },
]

export default {
  components: {
    DropdownButton,
    Icon,
    LoadingIcon
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu
    }
  },
  methods: {
    select(menuItem) {
      this.$emit('select', menuItem.value)
    }
  }
}
</script>